(function () {
  if (window.collectionTabsInitialized) {
    return;
  }

  window.collectionTabsInitialized = true;

  const SECTION_SELECTORS = ['.shopify-section--collection-banner', '.shopify-section--main-collection'];
  const LINK_SELECTOR = '[data-collection-tabs] a[href]';

  let controller = null;

  function setBusy(isBusy) {
    SECTION_SELECTORS.forEach((selector) => {
      const section = document.querySelector(selector);
      if (!section) return;

      if (isBusy) {
        section.setAttribute('aria-busy', 'true');
      } else {
        section.removeAttribute('aria-busy');
      }
    });
  }

  async function render(url, shouldPushState) {
    controller?.abort();
    controller = new AbortController();
    setBusy(true);

    try {
      const response = await fetch(url, { signal: controller.signal });

      if (!response.ok) {
        throw new Error(`Unexpected response status: ${response.status}`);
      }

      const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');

      const sections = SECTION_SELECTORS.map((selector) => ({
        current: document.querySelector(selector),
        next: nextDocument.querySelector(selector),
      }));

      if (sections.some(({ current, next }) => !current || !next)) {
        throw new Error('Collection sections missing from response');
      }

      sections.forEach(({ current, next }) => current.replaceWith(next));

      if (shouldPushState) {
        history.pushState({ collectionTabs: true }, '', url);
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }

      window.location.assign(url);
      return;
    } finally {
      setBusy(false);
    }
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest(LINK_SELECTOR);
    if (!link || link.target === '_blank') return;

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return;

    event.preventDefault();

    if (url.pathname === window.location.pathname) return;

    render(url.href, true);
  });

  window.addEventListener('popstate', () => {
    if (!document.querySelector(SECTION_SELECTORS[1])) return;

    render(window.location.href, false);
  });
})();
